import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-experience-platform-edge-network---validation"
    }}>{`Adobe Experience Platform Edge Network - Validation`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./edge-analytics-validation.md"
        }}>{`Edge Analytics Validation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./validation.md"
        }}>{`Edge Network Validation`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      